import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableNewFulfillmentPlanActivity = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableNewFulfillmentPlanActivity);
};
